import {
	ITranscludeFunction,
} from 'angular';

export default class ModalController {
	/* @ngInject */
	/**
	 * @param {ITranscludeFunction} $transclude
	 */
	constructor(
		$transclude,
	) {
		this.hasTitleSlot = $transclude.isSlotFilled('title');
		this.hasBodySlot = $transclude.isSlotFilled('body');
		this.hasFooterSlot = $transclude.isSlotFilled('footer');
	}
}
